module.exports = __webpack_public_path__ + "img/loader_mb.11b5a7ae.svg";